// @mui icons
import Icon from "@mui/material/Icon";
import AthleteProfile from "pages/AthleteProfile/AthleteProfile";
import GuardianProfile from "pages/AthleteProfile/GuardianProfile";
import { Dashboard, AthleteDashboard, AdminDashboard, ContentDashboard } from "pages/dashboard";
import ContentLibrary from "pages/contentLibrary/ContentLibrary";
import PlayList from "pages/playList/PlayList";
import AddContent from "pages/addContent/AddContent";
import MyGamePlan from "pages/myGamePlan/MyGamePlan";
import AddAnimalSummary from "pages/addAnimalSummary/addAnimalSummary";
import AddInsightsSummary from "pages/addInsightsSummary/addInsightsSummary";
import Faq from "pages/faq/Faq";
import Support from "pages/support/Support";
import Achievements from "pages/achievements/Achievements";
import ChatBotData from "pages/chatBotData/ChatBotData";
import ViewActivity from "pages/viewActivity/ViewActivity";

// Any new routes should be added here also
export const getAllRoutes = (t) => [
  {
    type: "route",
    name: t("routes.dashboard"),
    key: "dashboard",
    route: "/dashboard",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    component: <AthleteDashboard />,
  },
  {
    type: "route",
    name: t("routes.myLearnerDashboard"),
    key: "mylearnerdashboard",
    route: "/mylearnerdashboard",
    icon: <Icon fontSize="medium">school</Icon>,
    component: <AthleteDashboard />,
  },
  {
    type: "route",
    name: t("routes.contentLibrary"),
    key: "contentlibrary",
    route: "/contentlibrary",
    icon: <Icon fontSize="medium">collections_bookmark</Icon>,
    component: <ContentLibrary />,
  },
  {
    type: "route",
    name: t("routes.myContent"),
    key: "playlist",
    route: "/playlist",
    icon: <Icon fontSize="medium">playlist_play</Icon>,
    component: <PlayList />,
  },
  {
    type: "route",
    name: t("routes.profile"),
    key: "profile",
    route: "/profile",
    icon: <Icon fontSize="medium">account_circle</Icon>,
    component: <AthleteProfile />,
  },
  {
    type: "route",
    name: t("routes.myGamePlan"),
    key: "mygameplan",
    route: "/mygameplan",
    icon: <Icon fontSize="medium">sports</Icon>,
    component: <MyGamePlan />,
  },
  {
    type: "route",
    name: t("routes.viewActivity"),
    key: "viewactivity",
    route: "/viewactivity",
    icon: <Icon fontSize="medium">bar_chart</Icon>,
    component: <ViewActivity />,
  },
  {
    type: "route",
    name: t("routes.support"),
    key: "support",
    route: "/support",
    icon: <Icon fontSize="medium">headset_mic</Icon>,
    component: <Support />,
  },
  {
    type: "route",
    name: t("routes.faq"),
    key: "faq",
    route: "/faq",
    icon: <Icon fontSize="medium">help_outline</Icon>,
    component: <Faq />,
  },
  {
    type: "route",
    name: t("routes.achievements"),
    key: "achievements",
    route: "/achievements",
    icon: <Icon fontSize="medium">emoji_events</Icon>,
    component: <Achievements />,
    beta_route: false,
  },
  {
    type: "route",
    name: t("routes.addAnimalData"),
    key: "Add Animal Data",
    route: "/addAnimalSummary",
    icon: <Icon fontSize="medium">pets</Icon>,
    component: <AddAnimalSummary />,
  },
  {
    type: "route",
    name: t("routes.addInsightsData"),
    key: "Add Insights Data",
    route: "/addInsightsSummary",
    icon: <Icon fontSize="medium">psychology</Icon>,
    component: <AddInsightsSummary />,
  },
  {
    type: "route",
    name: t("routes.chatBotData"),
    key: "ChatBot Data",
    route: "/chatbotdata",
    icon: <Icon fontSize="medium">smart_toy</Icon>,
    component: <ChatBotData />,
  },
];

export const getAthleteRoutes = (t) => [
  {
    type: "route",
    name: t("routes.dashboard"),
    key: "dashboard",
    route: "/dashboard",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    component: <AthleteDashboard />,
  },
  {
    type: "route",
    name: t("routes.contentLibrary"),
    key: "contentlibrary",
    route: "/contentlibrary",
    icon: <Icon fontSize="medium">collections_bookmark</Icon>,
    component: <ContentLibrary />,
  },
  {
    type: "route",
    name: t("routes.myContent"),
    key: "playlist",
    route: "/playlist",
    icon: <Icon fontSize="medium">playlist_play</Icon>,
    component: <PlayList />,
  },
  {
    type: "route",
    name: t("routes.profile"),
    key: "profile",
    route: "/profile",
    icon: <Icon fontSize="medium">account_circle</Icon>,
    component: <AthleteProfile />,
  },
  {
    type: "route",
    name: t("routes.myGamePlan"),
    key: "mygameplan",
    route: "/mygameplan",
    icon: <Icon fontSize="medium">sports</Icon>,
    component: <MyGamePlan />,
  },
  {
    type: "route",
    name: t("routes.support"),
    key: "support",
    route: "/support",
    icon: <Icon fontSize="medium">headset_mic</Icon>,
    component: <Support />,
  },
  {
    type: "route",
    name: t("routes.faq"),
    key: "faq",
    route: "/faq",
    icon: <Icon fontSize="medium">help_outline</Icon>,
    component: <Faq />,
  },
  {
    type: "route",
    name: t("routes.achievements"),
    key: "achievements",
    route: "/achievements",
    icon: <Icon fontSize="medium">emoji_events</Icon>,
    component: <Achievements />,
    beta_route: false,
  },
];

export const getAdultRoutes = (t) => [
  {
    type: "route",
    name: t("routes.dashboard"),
    key: "dashboard",
    route: "/dashboard",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    component: <Dashboard />,
  },
  {
    type: "route",
    name: t("routes.contentLibrary"),
    key: "contentlibrary",
    route: "/contentlibrary",
    icon: <Icon fontSize="medium">collections_bookmark</Icon>,
    component: <ContentLibrary />,
  },
  {
    type: "route",
    name: t("routes.myContent"),
    key: "playlist",
    route: "/playlist",
    icon: <Icon fontSize="medium">playlist_play</Icon>,
    component: <PlayList />,
  },
  {
    type: "route",
    name: t("routes.viewActivity"),
    key: "viewactivity",
    route: "/viewactivity",
    icon: <Icon fontSize="medium">bar_chart</Icon>,
    component: <ViewActivity />,
  },
  {
    type: "route",
    name: t("routes.profile"),
    key: "profile",
    route: "/profile",
    icon: <Icon fontSize="medium">account_circle</Icon>,
    component: <GuardianProfile />,
  },
  {
    type: "route",
    name: t("routes.support"),
    key: "support",
    route: "/support",
    icon: <Icon fontSize="medium">headset_mic</Icon>,
    component: <Support />,
  },
  {
    type: "route",
    name: t("routes.faq"),
    key: "faq",
    route: "/faq",
    icon: <Icon fontSize="medium">help_outline</Icon>,
    component: <Faq />,
  },
];

export const getAdultAthleteRoutes = (t) => [
  {
    type: "route",
    name: t("routes.dashboard"),
    key: "dashboard",
    route: "/dashboard",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    component: <Dashboard />,
  },
  {
    type: "route",
    name: t("routes.myLearnerDashboard"),
    key: "mylearnerdashboard",
    route: "/mylearnerdashboard",
    icon: <Icon fontSize="medium">school</Icon>,
    component: <AthleteDashboard />,
  },
  {
    type: "route",
    name: t("routes.contentLibrary"),
    key: "contentlibrary",
    route: "/contentlibrary",
    icon: <Icon fontSize="medium">collections_bookmark</Icon>,
    component: <ContentLibrary />,
  },
  {
    type: "route",
    name: t("routes.myContent"),
    key: "playlist",
    route: "/playlist",
    icon: <Icon fontSize="medium">playlist_play</Icon>,
    component: <PlayList />,
  },
  {
    type: "route",
    name: t("routes.viewActivity"),
    key: "viewactivity",
    route: "/viewactivity",
    icon: <Icon fontSize="medium">bar_chart</Icon>,
    component: <ViewActivity />,
  },
  {
    type: "route",
    name: t("routes.profile"),
    key: "profile",
    route: "/profile",
    icon: <Icon fontSize="medium">account_circle</Icon>,
    component: <GuardianProfile />,
  },
  {
    type: "route",
    name: t("routes.myGamePlan"),
    key: "mygameplan",
    route: "/mygameplan",
    icon: <Icon fontSize="medium">sports</Icon>,
    component: <MyGamePlan />,
  },
  {
    type: "route",
    name: t("routes.support"),
    key: "support",
    route: "/support",
    icon: <Icon fontSize="medium">headset_mic</Icon>,
    component: <Support />,
  },
  {
    type: "route",
    name: t("routes.faq"),
    key: "faq",
    route: "/faq",
    icon: <Icon fontSize="medium">help_outline</Icon>,
    component: <Faq />,
  },
  {
    type: "route",
    name: t("routes.achievements"),
    key: "achievements",
    route: "/achievements",
    icon: <Icon fontSize="medium">emoji_events</Icon>,
    component: <Achievements />,
    beta_route: false,
  },
];

export const getAdminRoutes = (t) => [
  {
    type: "route",
    name: t("routes.dashboard"),
    key: "dashboard",
    route: "/dashboard",
    icon: <Icon fontSize="medium">admin_panel_settings</Icon>,
    component: <AdminDashboard />,
  },
  {
    type: "route",
    name: t("routes.profile"),
    key: "profile",
    route: "/profile",
    icon: <Icon fontSize="medium">account_circle</Icon>,
    component: <GuardianProfile />,
  },
  {
    type: "route",
    name: t("routes.chatBotData"),
    key: "ChatBot Data",
    route: "/chatbotdata",
    icon: <Icon fontSize="medium">smart_toy</Icon>,
    component: <ChatBotData />,
  },
];

export const getContentManagerRoutes = (t) => [
  {
    type: "route",
    name: t("routes.dashboard"),
    key: "Dashboard",
    route: "/dashboard",
    icon: <Icon fontSize="medium">space_dashboard</Icon>,
    component: <ContentDashboard />,
  },
  {
    type: "route",
    name: t("routes.profile"),
    key: "profile",
    route: "/profile",
    icon: <Icon fontSize="medium">account_circle</Icon>,
    component: <GuardianProfile />,
  },
  {
    type: "route",
    name: t("routes.addContent"),
    key: "Add Content",
    route: "/addcontent",
    icon: <Icon fontSize="medium">post_add</Icon>,
    component: <AddContent />,
  },
  {
    type: "route",
    name: t("routes.addAnimalData"),
    key: "Add Animal Data",
    route: "/addAnimalSummary",
    icon: <Icon fontSize="medium">pets</Icon>,
    component: <AddAnimalSummary />,
  },
  {
    type: "route",
    name: t("routes.addInsightsData"),
    key: "Add Insights Data",
    route: "/addInsightsSummary",
    icon: <Icon fontSize="medium">psychology</Icon>,
    component: <AddInsightsSummary />,
  },
  {
    type: "route",
    name: t("routes.chatBotData"),
    key: "ChatBot Data",
    route: "/chatbotdata",
    icon: <Icon fontSize="medium">smart_toy</Icon>,
    component: <ChatBotData />,
  },
];
